import gql from "graphql-tag.macro";
import { getClient } from "Globals/api";

const workflowStateFragment = gql`
    fragment WorkflowState on LoadWorkflowState {
        belongsTo
        currentProperties
        allStages {
            foo
            bar
            assgined {
                firstname
                lastname

            }
            assigneable {
                firstname
                lastname
            }
        }
        id
        pastChanges
        template
        type
    }
`;

const updateWorkflowStateMutation = gql`
    mutation UpdateWorkflowState($payload: WorkflowStateInputQuery!) {
        UpdateWorkflowState(workflowState: $payload) {
          ...WorkflowState
        }
    }
    ${workflowStateFragment}
`;

const updateWorkflowStateAssigneesMutation = gql`
    mutation UpdateWorkflowStateAssignees($payload: WorkflowStateAssigneesInputQuery!) {
        UpdateWorkflowStateAssignees(workflowState: $payload) {
          ...WorkflowState
        }
    }
    ${workflowStateFragment}
`;

const progressWorkflowStateMutation = gql`
    mutation ProgressWorkflowState($payload: WorkflowStateProgressQuery!) {
        ProgressWorkflowState(targetState: $payload) {
          ...WorkflowState
        }
    }
    ${workflowStateFragment}
`;

const loadWorkflowStateQuery = gql`
    query LoadWorkflowState($payload: WorkflowStateIdQuery!) {
        LoadWorkflowState(workflowStateId: $payload) {
          ...WorkflowState
        }
    }
    ${workflowStateFragment}
`;

const loadAllWorkflowStatesQuery = gql`
    query LoadAllWorkflowStates {
        LoadAllWorkflowStates {
            ...WorkflowState
        }
    }
    ${workflowStateFragment}
`;

export const loadWorkflowState = async ({ mdContext }) => {
    const client = await getClient("documentcontext");
    const { data } = await client.query({
        query: loadWorkflowStateQuery,
        variables: { payload: { type: "document", id: mdContext.document } },
    });
    return data;
};

export const loadAllWorkflowStates = async () => {
    const client = await getClient("documentcontext");
    const { data } = await client.query({
        query: loadAllWorkflowStatesQuery,
    });
    return data;
};

export const updateWorkflowState = async ({ mdContext, ...workflowState }) => {
    const client = await getClient("documentcontext");
    const { data } = await client.mutate({
        mutation: updateWorkflowStateMutation,
        variables: { payload: workflowState, type: "document", id: mdContext.document },
    });
    return data;
};

export const updateWorkflowStateAssignees = async ({ mdContext, ...payload }) => {
    const client = await getClient("documentcontext");
    const { data } = await client.mutate({
        mutation: updateWorkflowStateAssigneesMutation,
        variables: { payload: { ...payload, type: "document", id: mdContext.document } },
    });
    return data;
};

export const progressWorkflowState = async targetState => {
    const client = await getClient("documentcontext");
    const { data } = await client.mutate({
        mutation: progressWorkflowStateMutation,
        variables: { payload: targetState },
    });
    return data;
};
